import { render, staticRenderFns } from "./ProjectsDigestsItem.vue?vue&type=template&id=6c6cb7fe&scoped=true"
import script from "./ProjectsDigestsItem.vue?vue&type=script&lang=js"
export * from "./ProjectsDigestsItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectsDigestsItem.vue?vue&type=style&index=0&id=6c6cb7fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cb7fe",
  null
  
)

export default component.exports